<template>
  <div>
    <el-row type="flex" align="middle" :gutter="10">
      <el-col :span="16">
        <h3>Accreditation Details</h3>
        <span class="description"></span>
      </el-col>
      <el-col :span="8" class="d-flex flex-justify-end">
        <el-button
          type="default"
          @click="$router.push({ name: 'accreditations' })"
          >Close</el-button
        >
        <el-button type="primary" @click="submit">Submit</el-button>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-form
      ref="form"
      :model="value"
      :rules="rules"
      label-position="top"
    >
      <el-row :gutter="30">
        <el-col :span="8">
          <el-form-item prop="name" label="Name">
            <el-input v-model="value.name" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="isActive" label="Active">
            <el-select v-model="value.isActive" placeholder="Active">
              <el-option :value="true" label="Yes"></el-option>
              <el-option :value="false" label="No"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="entityType" label="Entity">
            <el-input v-model="value.entityType" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
        <el-form-item prop="expiryDuration" label="Expiry Duration">
          <el-select v-model="value.expiryDuration" placeholder="Select Duration">
            <el-option :value="'day'" label="Day"></el-option>
            <el-option :value="'month'" label="Month"></el-option>
            <el-option :value="'year'" label="Year"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item prop="expiryValue" label="Expiry Value">
          <el-input v-model="value.expiryValue" placeholder="Enter Value"></el-input>
        </el-form-item>
      </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="4">
          <el-form-item prop="expiryNotification" label="Expiry Notification">
            <el-select v-model="value.expiryNotification" placeholder="Notification">
              <el-option :value="true" label="Yes"></el-option>
              <el-option :value="false" label="No"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="expiryNotificationDays" label="Notification Days">
            <el-input-number v-model="value.expiryNotificationDays" :min="0" :max="365" placeholder="Days"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-form-item prop="description" label="Description">
            <el-input type="textarea" v-model="value.description" placeholder="Accreditation description" :rows="3"/>
          </el-form-item>
        </el-col>
      </el-row>

       <!-- Additional Fields Section -->
       <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="16">
          <h4>
            Additional Fields
            <el-tooltip content="Some accreditations require additional information, for example, WWC expiry. If additional fields are added, it provides the admin with the ability to assign additional accreditation information." placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </h4>
        </el-col>
        <el-col :span="8" class="text-right">
          <el-button type="primary" @click="addField" icon="el-icon-plus">Add Field</el-button>
        </el-col>
      </el-row>

      <!-- Dynamic Fields -->
      <el-row :gutter="20" class="mb-2">  <!-- Changed from mb-3 to mb-2 -->
        <el-col :span="8">
          <label class="el-form-item__label pt-0">Field Label</label>  <!-- Added pt-0 -->
        </el-col>
        <el-col :span="4">
          <label class="el-form-item__label pt-0">Field Type</label>
        </el-col>
        <el-col :span="4">
          <label class="el-form-item__label pt-0">Required Field</label>
        </el-col>
        <el-col :span="4">
          <label class="el-form-item__label pt-0">
            Display on Card
            <el-tooltip content="Only 2 additional fields can be shown on card at a time" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </label>
        </el-col>
        <el-col :span="4">
          <label class="el-form-item__label pt-0">&nbsp;</label>
        </el-col>
      </el-row>

      <!-- Form Fields -->
      <el-row v-for="(field, index) in value.additionalFields" :key="index" :gutter="20" class="mb-3">
        <el-col :span="8">
          <el-form-item :prop="`additionalFields.${index}.label`" :rules="fieldRules.label">
            <el-input v-model="field.label" placeholder="Field Label">
              <template slot="prepend">Label</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :prop="`additionalFields.${index}.type`" :rules="fieldRules.type">
            <el-select v-model="field.type" placeholder="Field Type">
              <el-option label="Text" value="text"></el-option>
              <el-option label="Date" value="date"></el-option>
              <el-option label="Number" value="number"></el-option>
              <el-option label="Yes/No" value="boolean"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :prop="`additionalFields.${index}.required`">
            <el-select v-model="field.required" placeholder="Required">
              <el-option :value="true" label="Required"></el-option>
              <el-option :value="false" label="Optional"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
  <el-form-item :prop="`additionalFields.${index}.displayOnCard`">
    <el-select
      v-model="field.displayOnCard"
      placeholder="Show on Card"
      @change="(val) => handleDisplayOnCardChange(val, index)"
    >
      <el-option :value="true" label="Show on Card"></el-option>
      <el-option :value="false" label="Hide on Card"></el-option>
    </el-select>
  </el-form-item>
</el-col>
        <el-col :span="4">
          <el-button type="danger" icon="el-icon-delete" @click="removeField(index)">Remove</el-button>
        </el-col>
      </el-row>

      <!-- file upload required -->
      <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="16">
          <h4>
            File Upload
          </h4>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="4">
          <el-form-item prop="fileUploadRequired" label="File Upload Required">
            <el-select v-model="value.fileUploadRequired" placeholder="Required">
              <el-option :value="true" label="Yes"></el-option>
              <el-option :value="false" label="No"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="uploadText" label="Upload Instructions">
            <el-input
              v-model="value.uploadText"
              placeholder="e.g. Please upload your WWC certificate"
              :disabled="!value.fileUploadRequired"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { requiredInput } from '@/utils/helpers';
import { timedate } from '@/utils/timedate';

export default {
  name: 'AccreditationForm',
  props: ['value'],
  components: {},
  data() {
    return {
      tab: 'details',
      rules: {
        name: requiredInput,
        uploadText: [
          {
            required: true,
            message: 'Upload instructions required when file upload is enabled',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (this.value.fileUploadRequired && !value) {
                callback(new Error('Upload instructions are required'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      fieldRules: {
        label: [{ required: true, message: 'Field label is required', trigger: 'blur' }],
        type: [{ required: true, message: 'Field type is required', trigger: 'change' }]
      }
    };
  },
  mounted() {},
  methods: {
    handleDisplayOnCardChange(newValue, changedIndex) {
      if (!newValue) return; // If turning off display, no need to check

      const displayedFields = this.value.additionalFields.filter(
        (field, idx) => idx !== changedIndex && field.displayOnCard
      );

      if (displayedFields.length >= 2) {
      // More than 2 fields would be displayed, prevent this
        this.value.additionalFields[changedIndex].displayOnCard = false;
        this.$message.error('Only 2 additional fields can be shown on card at a time');
      }
    },
    dateFormatter(r, c, val) {
      return timedate.set(val).fDate();
    },
    addField() {
      if (!this.value.additionalFields) {
        this.$set(this.value, 'additionalFields', []);
      }
      this.value.additionalFields.push({
        label: '',
        type: 'text',
        required: false,
        displayOnCard: false
      });
    },
    removeField(index) {
      this.value.additionalFields.splice(index, 1);
    },
    submit() {
      this.$refs.form
        .validate()
        .then((val) => {
          if (val) {
            this.$store.commit('loading', true);
            this.$http
              .put(
                `assemble/api/v1/admin/accreditations/${this.value._id}`,
                this.value
              )
              .then(() => {
                this.$message.success('Successful');
                this.$store.commit('loading', false);
              })
              .catch((error) => {
                this.$message.error(error.response.data.message);
                this.$store.commit('loading', false);
              });
          }
        })
        .catch(() => {});
    }
  },
  computed: {
    clearance() {
      return this.$store.getters['user/activeRoleType'];
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.el-form-item__label {
  padding-bottom: 4px;  /* Reduced from default */
}
</style>
